import React from "react";
import TransferItem from "./TransferItem";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../styles/styledTable";
import { TRANSFER_USER } from "../../../utils/consts";

const TransferList = ({ transfers, action, refetch, setRefetch }) => {
  const { t } = useTranslation("transferPage");

  const columnNamesByAction = {
    [TRANSFER_USER.RECEIVER]: t("table.receiver"),
    [TRANSFER_USER.SENDER]: t("table.sender"),
  };

  const reverseAction = action === TRANSFER_USER.RECEIVER
    ? TRANSFER_USER.SENDER
    : TRANSFER_USER.RECEIVER;

  if (!transfers) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (transfers.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable className="transfer-table_scroll">
      <StyledTable
        width="2030"
        size="14"
        className="transfer-table"
      >
        <StyledTableHead
          scroll="auto"
          col="10"
          className="transfer-table__head"
        >
          <div>
            Id
          </div>
          <div>
            {t("table.email")} {columnNamesByAction[reverseAction]}
          </div>
          <div>
            {t("table.service")}
          </div>
          <div>
            {t("table.currency")}
          </div>
          <div>
            {t("table.amount")}
          </div>
          <div>
            {t("table.status")}
          </div>
          <div>
            {t("table.createdAt")}
          </div>
          <div>
            {t("table.updatedAt")}
          </div>
          <div>
            {t("table.note")}
          </div>
          <div />
        </StyledTableHead>
        <StyledTableBody>
          {transfers && transfers.map((transfer, key) => (
            <TransferItem
              key={key}
              transfer={transfer}
              action={action}
              setRefetch={setRefetch}
              refetch={refetch}
              reverseAction={reverseAction}
            />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default TransferList;